import { ISuggestion } from "../../../../../models/Search";

export interface MapCybersecurityFiltersState {
  suggestions: ISuggestion[];
  edrpou?: string[];
  region?: string[];
  activeSuggestions: ISuggestion[];
  services: string[];
  company_size: string[];
  registration_date__gte?: string;
  registration_date__lte?: string;
  service_category: string[];
  company_type: string[];
  other_services?: string[];
  certifications?: boolean;
  lat_border__range?: any;
  lon_border__range?: any;
}

export enum MapFilterActionsEnum {
  SET_CYBERSECURITY_SERVICE = "SET_CYBERSECURITY_SERVICE",
  CLEAN_CYBERSECURITY_SERVICE = "CLEAN_CYBERSECURITY_SERVICE",

  SET_CYBERSECURITY_SERVICE_CATEGORY = "SET_CYBERSECURITY_SERVICE_CATEGORY",
  CLEAN_CYBERSECURITY_SERVICE_CATEGORY = "CLEAN_CYBERSECURITY_SERVICE_CATEGORY",

  SET_CYBERSECURITY_COMPANY_SIZE = "SET_CYBERSECURITY_COMPANY_SIZE",
  CLEAN_CYBERSECURITY_COMPANY_SIZE = "CLEAN_CYBERSECURITY_COMPANY_SIZE",
  SET_CYBERSECURITY_REGISTRATION_START_DATE = "SET_CYBERSECURITY_REGISTRATION_START_DATE",
  SET_CYBERSECURITY_REGISTRATION_END_DATE = "SET_CYBERSECURITY_REGISTRATION_END_DATE",

  CLEAN_CYBERSECURITY_REGISTRATION_DATE = "CLEAN_CYBERSECURITY_REGISTRATION_DATE",
  CLEAN_CYBERSECURITY_REGISTRATION_START_DATE = "CLEAN_CYBERSECURITY_REGISTRATION_START_DATE",
  CLEAN_CYBERSECURITY_REGISTRATION_END_DATE = "CLEAN_CYBERSECURITY_REGISTRATION_END_DATE",

  SET_CYBERSECURITY_COMPANY_TYPE = "SET_CYBERSECURITY_COMPANY_TYPE",
  CLEAN_CYBERSECURITY_COMPANY_TYPE = "CLEAN_CYBERSECURITY_COMPANY_TYPE",
  SET_CYBERSECURITY_SERVICES = "SET_CYBERSECURITY_SERVICES",
  CLEAN_CYBERSECURITY_SERVICES = "CLEAN_CYBERSECURITY_SERVICES",
  SET_CYBERSECURITY_OTHER_SERVICES = "SET_CYBERSECURITY_OTHER_SERVICES",
  CLEAN_CYBERSECURITY_OTHER_SERVICES = "CLEAN_CYBERSECURITY_OTHER_SERVICES",
  SET_CYBERSECURITY_CERTIFICATIONS = "SET_CYBERSECURITY_CERTIFICATIONS",
  CLEAN_CYBERSECURITY_CERTIFICATIONS = "CLEAN_CYBERSECURITY_CERTIFICATIONS",
  SET_CYBERSECURITY_SUGGESTION = "SET_CYBERSECURITY_SUGGESTION",
  SET_CYBERSECURITY_ACTIVE_SUGGESTION = "SET_CYBERSECURITY_ACTIVE_SUGGESTION",
  DELETE_CYBERSECURITY_ACTIVE_SUGGESTION = "DELETE_CYBERSECURITY_ACTIVE_SUGGESTION",
  CLEAN_CYBERSECURITY_SUGGESTION = "CLEAN_CYBERSECURITY_SUGGESTION",
}

export interface SetCybersecuritySuggestion {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_SUGGESTION;
  payload: ISuggestion[];
}

export interface SetCybersecurityActiveSuggestion {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_ACTIVE_SUGGESTION;
  payload: ISuggestion;
}

export interface DeleteCybersecurityActiveSuggestion {
  type: MapFilterActionsEnum.DELETE_CYBERSECURITY_ACTIVE_SUGGESTION;
  payload: ISuggestion;
}

export interface SetCybersecurityCleanSuggestion {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_SUGGESTION;
  payload: [];
}

export interface ToggleServiceCategory {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_SERVICE_CATEGORY;
  payload: string;
}

export interface CleanServiceCategory {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_SERVICE_CATEGORY;
  payload: [];
}

export interface ToggleCompanySize {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_COMPANY_SIZE;
  payload: string;
}

export interface CleanCompanySize {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_COMPANY_SIZE;
  payload: [];
}

export interface SetRegistrationStartDate {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_REGISTRATION_START_DATE;
  payload: string;
}

export interface SetRegistrationEndDate {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_REGISTRATION_END_DATE;
  payload: string;
}

export interface CleanRegistrationStartDate {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_REGISTRATION_START_DATE;
  payload: [];
}

export interface CleanRegistrationEndDate {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_REGISTRATION_END_DATE;
  payload: [];
}
export interface CleanRegistrationDate {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_REGISTRATION_DATE;
  payload: [];
}

export interface ToggleCompanyType {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_COMPANY_TYPE;
  payload: string;
}

export interface CleanCompanyType {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_COMPANY_TYPE;
  payload: [];
}

export interface ToggleServices {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_SERVICES;
  payload: string;
}

export interface CleanServices {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_SERVICES;
  payload: [];
}

export interface SetOtherServices {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_OTHER_SERVICES;
  payload: string;
}

export interface CleanOtherServices {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_OTHER_SERVICES;
  payload: [];
}

export interface SetCertifications {
  type: MapFilterActionsEnum.SET_CYBERSECURITY_CERTIFICATIONS;
  payload: boolean;
}

export interface CleanCertifications {
  type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_CERTIFICATIONS;
  payload: [];
}

export type MapFiltersAction =
  | SetCybersecuritySuggestion
  | SetCybersecurityActiveSuggestion
  | DeleteCybersecurityActiveSuggestion
  | SetCybersecurityCleanSuggestion
  | ToggleServiceCategory
  | CleanServiceCategory
  | ToggleCompanySize
  | CleanCompanySize
  | SetRegistrationStartDate
  | SetRegistrationEndDate
  | CleanRegistrationStartDate
  | CleanRegistrationEndDate
  | CleanRegistrationDate
  | ToggleCompanyType
  | CleanCompanyType
  | ToggleServices
  | CleanServices
  | SetOtherServices
  | CleanOtherServices
  | SetCertifications
  | CleanCertifications;
